var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wpdonation-box" },
    [
      _vm.strings
        ? _c("h2", { staticClass: "wpdonation-title" }, [
            _vm._v(_vm._s(_vm.strings.title))
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "easy-donation-box" }, [
        _c("div", { staticClass: "single-credit-cardd" }, [
          _c("div", { staticClass: "wpcm-row wpmc-justify-content-center" }, [
            _c("div", { staticClass: "wpcm-col-md-6" }, [
              _c("div", { staticClass: "textfield" }, [
                _c("input", {
                  attrs: {
                    type: "text",
                    placeholder: _vm.trans("first_name"),
                    disabled: _vm.loading,
                    required: ""
                  },
                  domProps: { value: _vm.billing_fields.first_name },
                  on: {
                    input: function($event) {
                      return _vm.setBillingValue(
                        "first_name",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "wpcm-col-md-6" }, [
              _c("div", { staticClass: "textfield" }, [
                _c("input", {
                  attrs: {
                    type: "text",
                    placeholder: _vm.trans("last_name"),
                    disabled: _vm.loading,
                    required: ""
                  },
                  domProps: { value: _vm.billing_fields.last_name },
                  on: {
                    input: function($event) {
                      return _vm.setBillingValue(
                        "last_name",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "wpcm-col-md-12" }, [
              _c("div", { staticClass: "textfield" }, [
                _c("input", {
                  attrs: {
                    type: "email",
                    placeholder: _vm.trans("email"),
                    readonly: _vm.is_logged_in && _vm.email,
                    disabled: _vm.loading,
                    required: ""
                  },
                  domProps: { value: _vm.billing_fields.email },
                  on: {
                    input: function($event) {
                      return _vm.setBillingValue("email", $event.target.value)
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "wpcm-col-md-12" }, [
              _c("div", { staticClass: "textfield" }, [
                _c("input", {
                  attrs: {
                    type: "text",
                    placeholder: _vm.trans("address"),
                    disabled: _vm.loading
                  },
                  domProps: { value: _vm.billing_fields.address },
                  on: {
                    input: function($event) {
                      return _vm.setBillingValue("address", $event.target.value)
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _vm.show_company
              ? _c("div", { staticClass: "wpcm-col-md-12" }, [
                  _c("div", { staticClass: "textfield" }, [
                    _c("input", {
                      attrs: {
                        type: "text",
                        placeholder: _vm.trans("company"),
                        disabled: _vm.loading
                      },
                      domProps: { value: _vm.billing_fields.company },
                      on: {
                        input: function($event) {
                          return _vm.setBillingValue(
                            "company",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.show_country
              ? _c("div", { staticClass: "wpcm-col-md-12" }, [
                  _c(
                    "div",
                    { staticClass: "textfield" },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: _vm.trans("country"),
                            loading: _vm.select_loading
                          },
                          on: {
                            change: function($event) {
                              return _vm.setBillingValue("base_country", $event)
                            }
                          },
                          model: {
                            value: _vm.country,
                            callback: function($$v) {
                              _vm.country = $$v
                            },
                            expression: "country"
                          }
                        },
                        _vm._l(_vm.countries, function(name, key) {
                          return _c("el-option", {
                            key: key,
                            attrs: { label: name, value: key }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.show_county
              ? _c("div", { staticClass: "wpcm-col-md-12" }, [
                  _c("div", { staticClass: "textfield" }, [
                    _c("input", {
                      attrs: {
                        type: "text",
                        placeholder: _vm.trans("county"),
                        disabled: _vm.loading
                      },
                      domProps: { value: _vm.billing_fields.state },
                      on: {
                        input: function($event) {
                          return _vm.setBillingValue(
                            "state",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.show_city
              ? _c("div", { staticClass: "wpcm-col-md-12" }, [
                  _c("div", { staticClass: "textfield" }, [
                    _c("input", {
                      attrs: {
                        type: "text",
                        placeholder: _vm.trans("city"),
                        disabled: _vm.loading
                      },
                      domProps: { value: _vm.billing_fields.city },
                      on: {
                        input: function($event) {
                          return _vm.setBillingValue(
                            "city",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.show_phone_no
              ? _c("div", { staticClass: "wpcm-col-md-12" }, [
                  _c("div", { staticClass: "textfield" }, [
                    _c("input", {
                      attrs: {
                        type: "text",
                        placeholder: _vm.trans("phone_no"),
                        disabled: _vm.loading
                      },
                      domProps: { value: _vm.billing_fields.phone_no },
                      on: {
                        input: function($event) {
                          return _vm.setBillingValue(
                            "phone_no",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.show_postal
              ? _c("div", { staticClass: "wpcm-col-md-12" }, [
                  _c("div", { staticClass: "textfield" }, [
                    _c("input", {
                      attrs: {
                        type: "text",
                        placeholder: _vm.trans("postal_code"),
                        disabled: _vm.loading
                      },
                      domProps: { value: _vm.billing_fields.zip },
                      on: {
                        input: function($event) {
                          return _vm.setBillingValue("zip", $event.target.value)
                        }
                      }
                    })
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.show_tax
              ? _c("div", { staticClass: "wpcm-col-md-12" }, [
                  _c("div", { staticClass: "textfield" }, [
                    _c("input", {
                      attrs: {
                        type: "text",
                        placeholder: _vm.trans("tax_code"),
                        disabled: _vm.loading
                      },
                      domProps: { value: _vm.billing_fields.tax_code },
                      on: {
                        input: function($event) {
                          return _vm.setBillingValue(
                            "tax_code",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ])
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }